const state = {
    applicationTabView: Ambition.isIgnition() ? "compact" : "kanban",
    sortby: {
        prop: {},
        order: "ascending"
    },
    tableSettings: {
        pageSize: 20,
        columnsInUse: [
            { name: "Assigned" },
            { name: "Asset" },
            { name: "Status" },
            { name: "Reference Id" },
            { name: "Referrer" },
            { name: "Lender" }
        ]
    },
    applicationView: 'v2'
}

const getters = {
    applicationTabView: state => state.applicationTabView,
    sortby: state => state.sortby,
    tableSettings: state => state.tableSettings,
    applicationView: state => state.applicationView
}

const mutations = {
    setApplicationTabView(state, view) {
        axios
            .put("/api/v2/user-settings", {
                applicationTabView: view
            }, $store.getters.token).then(res => {
                state.applicationTabView = view
            });
    },
    setApplicationTabSortBy(state, sortby) {
        state.sortby = sortby
    },
    setApplicationTableSettings(state, settings) {
        state.tableSettings = Object.assign(state.tableSettings, settings)
    },
    setapplicationView(state, appView) {
        state.applicationView = appView
    }
}

const actions = {
    saveApplicationTabView(context, view) {
        context.commit("setApplicationTabView", view)
    },
    saveApplicationTabSortBy(context, sortby) {
        context.commit("setApplicationTabSortBy", sortby)
    },
    saveApplicationTableSettings(context, settings) {
        context.commit("setApplicationTableSettings", settings)
    },
    saveApplicationView(context, appView) {
        context.commit("setapplicationView", appView)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
